<template>
    <div class="flex flex-col gap-4 mt-3">
        <a id="global-catalog-product-detail-back" class="flex items-center justify-start cursor-pointer"
            @click="goBack()">
            <i class="ri-arrow-left-s-line text-[#762123] text-xl"></i>
            <span class="font-normal text-base underline underline-offset-4 text-[#762123]">Back</span>
        </a>
        <Loader v-if="globalCatalogStore.loading" />
        <ProductCard v-else-if="product"
            :key="`${product?.productId}-${globalCatalogStore.selectedBranch?.BranchCode || ''}-${globalCatalogStore.selectedJobAccount?.ShipToSequenceId || ''}`"
            :product="product" :index="0" />
    </div>
</template>

<script setup>
import { useGlobalCatalogStore } from '@/stores/globalCatalogStore';
import { computed } from 'vue';
import ProductCard from '@/components/GlobalCatalog/Products/ProductCard.vue';
import Loader from "@/components/atoms/Loader.vue";

const globalCatalogStore = useGlobalCatalogStore();
const product = computed(() => globalCatalogStore.selectedProduct);
const emit = defineEmits(['back']);

const goBack = () => {
    emit('back')
    globalCatalogStore.goBack();
    globalCatalogStore.isTemplateSingleton = false;
    // Reset currentTierId only if not inside OrderCatalogSlider (slider has its own cleanup in closeDrawer)
    // Check if we're going back to a non-slider view (isOpenCatalogSlider will be false when opened directly from BOM)
    if (!globalCatalogStore.isOpenCatalogSlider && globalCatalogStore.currentTierId !== null) {
        globalCatalogStore.currentTierId = null;
    }
}
</script>